// import React, { useState, useEffect, useRef } from "react";
// import { useNavigate, Link } from "react-router-dom";
// import Filter from "../../../Assets/Images/CommanImages/filter.png";
// import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
// import updown from "../../../Assets/Images/CommanImages/updown.png";
// import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
// import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
// import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
// import FileSaver from "file-saver";
// import * as XLSX from "xlsx";
// import jsPDF from "jspdf";
// import "jspdf-autotable";
// import EndPoints from "../../../Api/Endpoints";
// import { GET } from "../../../Api/HttpsMethods";

// // ─── TableComponent ───────────────────────────────────────────────────────────
// const TableComponent = ({ columnLabels, groupedRows, searchPlaceholder }) => {
//   const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
//   const [searchQuery, setSearchQuery] = useState("");
//   const [visibleColumns, setVisibleColumns] = useState([]);
//   const [sortConfig, setSortConfig] = useState({ key: null, direction: "desc" });
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const columnDropdownRef = useRef(null);
//   const navigate = useNavigate();

//   // columnLabels: ["Schedule Date", "Scheduled By", "Course", "Question Count"]
//   useEffect(() => {
//     if (columnLabels.length > 0) {
//       setVisibleColumns(columnLabels.slice(0, columnLabels.length));
//       setSortConfig({ key: columnLabels[0], direction: "desc" });
//     }
//   }, [columnLabels]);

//   const handleColumnSelection = (col) => {
//     setVisibleColumns((prev) =>
//       prev.includes(col) ? prev.filter((c) => c !== col) : [...prev, col]
//     );
//   };

//   const handleSearch = (e) => {
//     setSearchQuery(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleSort = (col) => {
//     setSortConfig((prev) => ({
//       key: col,
//       direction: prev.key === col && prev.direction === "asc" ? "desc" : "asc",
//     }));
//   };

//   // groupedRows: [{ scheduleDate, scheduledBy, course, questionTexts: [], rawDate }]
//   const filteredRows = groupedRows.filter((row) =>
//     [row.scheduleDate, row.scheduledBy, row.course, ...(row.questionTexts || [])].some(
//       (val) => String(val).toLowerCase().includes(searchQuery.toLowerCase())
//     )
//   );

//   const sortedRows = React.useMemo(() => {
//     if (!sortConfig.key) return filteredRows;
//     return [...filteredRows].sort((a, b) => {
//       const colKeyMap = {
//         "Schedule Date": "scheduleDate",
//         "Scheduled By": "scheduledBy",
//         Course: "course",
//         "Questions": "scheduleDate", // sort questions column by date
//       };
//       const key = colKeyMap[sortConfig.key] || "scheduleDate";
//       const aVal = a[key];
//       const bVal = b[key];
//       if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
//       if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
//       return 0;
//     });
//   }, [filteredRows, sortConfig]);

//   const totalPages = Math.ceil(sortedRows.length / pageSize);
//   const paginatedRows = sortedRows.slice(
//     (currentPage - 1) * pageSize,
//     currentPage * pageSize
//   );

//   const handlePageChange = (page) => setCurrentPage(page);
//   const handlePageSizeChange = (size) => {
//     setPageSize(size);
//     setCurrentPage(1);
//   };

//   const getCellValue = (row, colLabel) => {
//     const map = {
//       "Schedule Date": row.scheduleDate,
//       "Scheduled By": row.scheduledBy,
//       Course: row.course,
//       // For export, join question texts as newline-separated string
//       Questions: (row.questionTexts || []).map((q, i) => `${i + 1}. ${q}`).join("\n"),
//     };
//     return map[colLabel] ?? "";
//   };

//   const handleExport = (type) => {
//     const exportData = sortedRows.map((row) =>
//       visibleColumns.map((col) => getCellValue(row, col))
//     );
//     const fileName = prompt("Enter the file name:");
//     if (!fileName) return;

//     if (type === "excel" || type === "csv") {
//       const ws = XLSX.utils.aoa_to_sheet([visibleColumns, ...exportData]);
//       const wb = XLSX.utils.book_new();
//       XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
//       const ext = type === "csv" ? "csv" : "xlsx";
//       const mime =
//         type === "csv"
//           ? "text/csv"
//           : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
//       const file = XLSX.write(wb, { bookType: ext, type: "array" });
//       FileSaver.saveAs(new Blob([file], { type: mime }), `${fileName}.${ext}`);
//     } else if (type === "pdf") {
//       const doc = new jsPDF();
//       doc.autoTable({ head: [visibleColumns], body: exportData });
//       doc.save(`${fileName}.pdf`);
//     }
//   };

//   const renderPagination = () => {
//     const pages = [];
//     const addBtn = (i) =>
//       pages.push(
//         <button
//           key={i}
//           onClick={() => handlePageChange(i)}
//           style={{ borderRadius: "5px" }}
//           className={i === currentPage ? "active" : ""}
//         >
//           {i}
//         </button>
//       );
//     const addDots = (k) =>
//       pages.push(
//         <span key={k} style={{ borderRadius: "5px" }}>
//           ...
//         </span>
//       );

//     if (totalPages <= 5) {
//       for (let i = 1; i <= totalPages; i++) addBtn(i);
//     } else if (currentPage <= 3) {
//       for (let i = 1; i <= 3; i++) addBtn(i);
//       addDots("d1");
//       addBtn(totalPages);
//     } else if (currentPage > 3 && currentPage < totalPages - 2) {
//       addBtn(1);
//       addDots("d1");
//       for (let i = currentPage - 1; i <= currentPage + 1; i++) addBtn(i);
//       addDots("d2");
//       addBtn(totalPages);
//     } else {
//       addBtn(1);
//       addDots("d1");
//       for (let i = totalPages - 2; i <= totalPages; i++) addBtn(i);
//     }
//     return pages;
//   };

//   useEffect(() => {
//     const handleClickOutside = (e) => {
//       if (columnDropdownRef.current && !columnDropdownRef.current.contains(e.target)) {
//         setIsColumnDivVisible(false);
//       }
//     };
//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div>
//       {/* Search + record count row */}
//       <div
//         style={{
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "space-between",
//           marginTop: "1.5%",
//         }}
//       >
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "space-between",
//             width: "82vw",
//           }}
//         >
//           <div
//             style={{
//               display: "flex",
//               alignItems: "center",
//               border: "1px solid #6A6A6A",
//               overflow: "hidden",
//             }}
//           >
//             <input
//               type="text"
//               placeholder={searchPlaceholder}
//               name="search"
//               className="search-input-ques-dash"
//               onChange={handleSearch}
//             />
//             <div
//               style={{
//                 width: "1px",
//                 height: "24px",
//                 backgroundColor: "#2F2E40",
//                 margin: "0 4px",
//               }}
//             />
//             <img src={searchicon} alt="search" className="search-icon-ques-dash" />
//           </div>
//           <div style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}>
//             Displaying{" "}
//             {Math.min((currentPage - 1) * pageSize + 1, sortedRows.length)} –{" "}
//             {Math.min(currentPage * pageSize, sortedRows.length)} of{" "}
//             {sortedRows.length} records |{" "}
//             {["10", "25", "50", "100", "500"].map((size) => (
//               <span
//                 key={size}
//                 onClick={() => handlePageSizeChange(Number(size))}
//                 style={{
//                   cursor: "pointer",
//                   margin: "0 5px",
//                   textDecoration: size === pageSize.toString() ? "none" : "underline",
//                   color: size === pageSize.toString() ? "black" : "#337AB7",
//                 }}
//               >
//                 {size}
//               </span>
//             ))}
//           </div>
//         </div>
//       </div>

//       {/* Filter / Column selection bar */}
//       <div
//         style={{
//           display: "flex",
//           backgroundColor: "#D6D6D6",
//           marginTop: "9px",
//           borderTop: "1px solid grey",
//           borderBottom: "1px solid grey",
//         }}
//       >
//         {/* Export button */}
//         <div
//           style={{
//             display: "flex",
//             alignItems: "center",
//             cursor: "pointer",
//             paddingLeft: "8px",
//             width: "90px",
//             backgroundColor: "#FFBD20",
//           }}
//           onClick={() => setIsModalVisible(true)}
//         >
//           <img src={Filter} style={{ height: "24px", width: "24px" }} alt="export" />
//           <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Export</span>
//         </div>

//         {/* Column selection */}
//         <div
//           style={{
//             marginLeft: "auto",
//             textAlign: "end",
//             marginRight: "8px",
//             display: "flex",
//             alignItems: "center",
//             position: "relative",
//             cursor: "pointer",
//             height: "40px",
//           }}
//           onClick={(e) => {
//             if (!columnDropdownRef.current?.contains(e.target)) {
//               setIsColumnDivVisible((v) => !v);
//             }
//           }}
//         >
//           <img
//             src={columnaddition}
//             style={{ height: "34px", width: "32px" }}
//             alt="column addition"
//           />
//           <span
//             style={{
//               marginLeft: "4px",
//               color: "#2F2E40",
//               marginRight: "14px",
//               fontSize: "14px",
//             }}
//           >
//             Column Selection
//           </span>
//           {isColumnDivVisible && (
//             <>
//               <div className="arrow-up-tc" />
//               <div className="popupColumn-tc" ref={columnDropdownRef}>
//                 {/* First column always locked */}
//                 <div>
//                   <input
//                     type="checkbox"
//                     id="col-lock"
//                     className="square-checkbox-tc"
//                     checked
//                     readOnly
//                     disabled
//                   />
//                   <label htmlFor="col-lock">{columnLabels[0]}</label>
//                 </div>
//                 {columnLabels.slice(1).map((col, i) => (
//                   <div key={i} onClick={() => handleColumnSelection(col)}>
//                     <input
//                       type="checkbox"
//                       id={`col-${i}`}
//                       className="square-checkbox-tc"
//                       checked={visibleColumns.includes(col)}
//                       readOnly
//                     />
//                     <label htmlFor={`col-${i}`}>{col}</label>
//                   </div>
//                 ))}
//               </div>
//             </>
//           )}
//         </div>
//       </div>

//       {/* Table */}
//       <div className="table-wrapper-cols-selections">
//         <table className="table-tc mcq-dashboard-table" style={{ width: "100%" }}>
//           <thead>
//             <tr>
//               {visibleColumns.map((col, i) => (
//                 <td
//                   key={i}
//                   className="Heading-tc"
//                   style={{ textAlign: "left", cursor: "pointer" }}
//                 >
//                   <span
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       color: "#424242",
//                     }}
//                   >
//                     {col}
//                     <img
//                       onClick={() => handleSort(col)}
//                       src={updown}
//                       style={{ height: "20px", width: "20px", marginLeft: "5px" }}
//                       alt="sort"
//                     />
//                   </span>
//                 </td>
//               ))}
//             </tr>
//           </thead>
//           <tbody>
//             {paginatedRows.map((row, rowIdx) => (
//               <tr key={rowIdx} className={rowIdx % 2 === 1 ? "even-row-tc" : ""}>
//                 {visibleColumns.map((col, cellIdx) => (
//                   <td
//                     key={cellIdx}
//                     style={{
//                       textAlign: "left",
//                       color: "#6A6A6A",
//                       maxWidth: col === "Questions" ? "none" : "220px",
//                       verticalAlign: col === "Questions" ? "top" : "middle",
//                       paddingLeft: col === "Questions" ? "8px" : undefined,
//                     }}
//                   >
//                     {col === "Schedule Date" ? (
//                       <div className="truncate-cell" title={row.scheduleDate}>
//                         <Link
//                           style={{ color: "#337ab7" }}
//                           to={`/mcq_of_day_edit?date=${encodeURIComponent(row.scheduleDate)}&course=${encodeURIComponent(row.course)}&courseId=${encodeURIComponent(row.courseId || "")}&scheduledBy=${encodeURIComponent(row.scheduledBy)}`}
//                         >
//                           {row.scheduleDate
//                             ? (() => {
//                                 const d = new Date(row.scheduleDate);
//                                 if (isNaN(d)) return row.scheduleDate;
//                                 const dd = String(d.getDate()).padStart(2, "0");
//                                 const mm = String(d.getMonth() + 1).padStart(2, "0");
//                                 const yyyy = d.getFullYear();
//                                 return `${dd}-${mm}-${yyyy}`;
//                               })()
//                             : ""}
//                         </Link>
//                       </div>
//                     ) : col === "Questions" ? (
//                       <div style={{ display: "flex", flexDirection: "column", padding: "4px 0", alignItems: "flex-start", width: "100%" }}>
//                         {(row.questionTexts || []).map((qt, qi) => {
//                           const isLast = qi === (row.questionTexts || []).length - 1;
//                           return (
//                             <div
//                               key={qi}
//                               style={{
//                                 fontSize: "13px",
//                                 color: "#6A6A6A",
//                                 lineHeight: "1.4",
//                                 display: "flex",
//                                 alignItems: "flex-start",
//                                 gap: "4px",
//                                 width: "100%",
//                                 paddingBottom: isLast ? "0" : "6px",
//                                 marginBottom: isLast ? "0" : "6px",
//                                 borderBottom: isLast ? "none" : "1px solid #e8e8e6",
//                               }}
//                               title={qt}
//                             >
//                               <span style={{ color: "#6A6A6A", fontWeight: 400, minWidth: "18px", flexShrink: 0 }}>
//                                 {qi + 1}.
//                               </span>
//                               <span>{qt}</span>
//                             </div>
//                           );
//                         })}
//                       </div>
//                     ) : (
//                       <div className="truncate-cell" title={String(getCellValue(row, col))}>
//                         {getCellValue(row, col)}
//                       </div>
//                     )}
//                   </td>
//                 ))}
//               </tr>
//             ))}
//             {paginatedRows.length === 0 && (
//               <tr>
//                 <td
//                   colSpan={visibleColumns.length}
//                   style={{ textAlign: "center", padding: "24px", color: "#6A6A6A" }}
//                 >
//                   No records found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Pagination */}
//       <div className="pagination-tc">
//         <button
//           onClick={() => handlePageChange(1)}
//           disabled={currentPage === 1}
//           className="extreme-left-tc-pagination"
//         >
//           <img src={leftArrow} alt="" />
//         </button>
//         <button
//           onClick={() => handlePageChange(currentPage - 1)}
//           disabled={currentPage === 1}
//           className="lefttc-pagination"
//         >
//           {"<"}
//         </button>
//         {renderPagination()}
//         <button
//           onClick={() => handlePageChange(currentPage + 1)}
//           disabled={currentPage === totalPages || totalPages === 0}
//           className="righttc-pagination"
//         >
//           {">"}
//         </button>
//         <button
//           onClick={() => handlePageChange(totalPages)}
//           disabled={currentPage === totalPages || totalPages === 0}
//           className="extreme-right-tc-pagination"
//         >
//           <img src={rightArrow} alt="" />
//         </button>
//       </div>

//       {/* Export modal */}
//       {isModalVisible && (
//         <div>
//           <div className="arrow-up-tc-QB" />
//           <div className="arrow-up-tc-QB-model">
//             <div className="modal-content-tc">
//               <h3>Select Export File Type</h3>
//               <button onClick={() => { handleExport("excel"); setIsModalVisible(false); }}>
//                 Excel
//               </button>
//               <button onClick={() => { handleExport("csv"); setIsModalVisible(false); }}>
//                 CSV
//               </button>
//               <button onClick={() => { handleExport("pdf"); setIsModalVisible(false); }}>
//                 PDF
//               </button>
//               <button onClick={() => setIsModalVisible(false)}>Cancel</button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// // ─── MCQDayDashboard (page-level) ─────────────────────────────────────────────
// const MCQDayDashboard = ({
//   setMessageBox,
//   setIsMessageBoxVisible,
//   setActiveImg,
//   dataClient,
// }) => {
//   const navigate = useNavigate();
//   const [groupedRows, setGroupedRows] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);

//   // Extract client info from dataClient (same pattern as rest of codebase)
//   const clientBranchId =
//     dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
//     sessionStorage.getItem("clientBranchId") ||
//     null;

//   useEffect(() => {
//     if (dataClient) {
//       const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
//       const branchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
//       const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
//       sessionStorage.setItem("user_name", userName);
//       sessionStorage.setItem("clientBranchId", branchId);
//       sessionStorage.setItem("clientId", clientId);
//     }
//   }, [dataClient]);

//   useEffect(() => {
//     fetchMCQDashboardData();
//   }, []);

//   // const fetchMCQDashboardData = async () => {
//   //   setLoading(true);
//   //   setError(null);
//   //   try {
//   //     // Step 1: get all courses
//   //     const courses = await GET.withToken(EndPoints.PRISM_GET_COURSES);
//   //     if (!Array.isArray(courses) || courses.length === 0) {
//   //       setGroupedRows([]);
//   //       return;
//   //     }

//   //     // Step 2: fetch MCQs for each course in parallel
//   //     // API param: course_id (integer)
//   //     const results = await Promise.allSettled(
//   //       courses.map((c) =>
//   //         GET.withToken(
//   //           `${EndPoints.PRISM_GET_ALL_MCQ_OF_DAY_BY_COURSE}?course_id=${c.course_id}`
//   //         )
//   //       )
//   //     );

//   //     // Step 3: merge all data rows, group by (rawDate + course)
//   //     // Row layout from API: [scheduleDate, scheduledBy, course, questionText, questionId]
//   //     const DATE_IDX = 0;
//   //     const BY_IDX = 1;
//   //     const COURSE_IDX = 2;
//   //     const TEXT_IDX = 3;

//   //     const groupMap = new Map();

//   //     results.forEach((result, idx) => {
//   //       if (result.status !== "fulfilled" || !result.value) return;
//   //       const data = result.value;
//   //       const courseId = courses[idx]?.course_id || null;
//   //       const dataRows = Array.isArray(data.headers)
//   //         ? data.headers.filter((h) => Array.isArray(h))
//   //         : [];

//   //       dataRows.forEach((row) => {
//   //         const rawDate = row[DATE_IDX];
//   //         const course = row[COURSE_IDX] || "";
//   //         const scheduledBy = row[BY_IDX] || "";
//   //         const questionText = row[TEXT_IDX] || "";
//   //         const displayDate = rawDate ? rawDate.split(" ")[0] : rawDate;
//   //         const key = `${rawDate}__${course}`;

//   //         if (!groupMap.has(key)) {
//   //           groupMap.set(key, {
//   //             rawDate,
//   //             scheduleDate: displayDate,
//   //             scheduledBy,
//   //             course,
//   //             courseId,           // ← passed to edit page via Link query param
//   //             questionTexts: [],
//   //           });
//   //         }
//   //         if (questionText) {
//   //           groupMap.get(key).questionTexts.push(questionText);
//   //         }
//   //       });
//   //     });

//   //     setGroupedRows(Array.from(groupMap.values()));
//   //   } catch (err) {
//   //     console.error("Error fetching MCQ dashboard data:", err);
//   //     setError(err.message);
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };


//   const fetchMCQDashboardData = async () => {
//     setLoading(true);
//     setError(null);
//     try {
//       const data = await GET.withToken(EndPoints.PRISM_GET_ALL_MCQ_OF_DAY_BY_COURSE);

//       const DATE_IDX = 0;
//       const BY_IDX = 1;
//       const COURSE_IDX = 2;
//       const TEXT_IDX = 3;

//       const groupMap = new Map();

//       const dataRows = Array.isArray(data.headers)
//         ? data.headers.filter((h) => Array.isArray(h))
//         : [];

//       dataRows.forEach((row) => {
//         const rawDate = row[DATE_IDX];
//         const course = row[COURSE_IDX] || "";
//         const scheduledBy = row[BY_IDX] || "";
//         const questionText = row[TEXT_IDX] || "";
//         const displayDate = rawDate ? rawDate.split(" ")[0] : rawDate;
//         const key = `${rawDate}__${course}`;

//         if (!groupMap.has(key)) {
//           groupMap.set(key, {
//             rawDate,
//             scheduleDate: displayDate,
//             scheduledBy,
//             course,
//             courseId: null,
//             questionTexts: [],
//           });
//         }
//         if (questionText) {
//           groupMap.get(key).questionTexts.push(questionText);
//         }
//       });

//       setGroupedRows(Array.from(groupMap.values()));
//     } catch (err) {
//       console.error("Error fetching MCQ dashboard data:", err);
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const columnLabels = ["Schedule Date", "Scheduled By", "Course", "Questions"];

//   return (
//     <div
//       style={{
//         height: "auto",
//         width: "100%",
//         paddingLeft: "20px",
//         marginBottom: "40px",
//       }}
//     >
//       <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
//         {/* Page header */}
//         <div className="create-role-container-ques-dashboards">
//           <p style={{ color: "#2F2E40", fontSize: "30px" }}>MCQ of the Day Dashboard</p>
//           <div
//             style={{
//               display: "flex",
//               justifyItems: "center",
//               alignItems: "center",
//               gap: "12px",
//             }}
//           >
//             {/* New MCQ of Day button → /mcq_of_day */}
//             <button
//               className="create-test-section-btn"
//               onClick={() => navigate("/mcq_of_day")}
//               style={{
//                 marginRight: "18px",
//                 boxShadow: "0px 4px 4px 0px #00000040",
//               }}
//             >
//               <span className="plus-icon-create">+</span>MCQ OF DAY
//             </button>
//           </div>
//         </div>

//         <p style={{ marginTop: "1%", color: "#2F2E40" }}>
//           View and manage MCQ of the Day schedules. Click on a date to edit.
//         </p>

//         {loading && (
//           <p style={{ color: "#6A6A6A", marginTop: "12px" }}>Loading…</p>
//         )}
//         {error && (
//           <p style={{ color: "red", marginTop: "12px" }}>Error: {error}</p>
//         )}

//         {!loading && !error && (
//           <TableComponent
//             columnLabels={columnLabels}
//             groupedRows={groupedRows}
//             searchPlaceholder="Search MCQ schedules…"
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default MCQDayDashboard;
























import React, { useState, useEffect, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import he from "he";
import Latex from "react-latex";
import "katex/dist/katex.min.css";
import Filter from "../../../Assets/Images/CommanImages/filter.png";
import columnaddition from "../../../Assets/Images/CommanImages/flat-color-icons_add-column.png";
import updown from "../../../Assets/Images/CommanImages/updown.png";
import searchicon from "../../../Assets/Images/CommanImages/searchyellow.png";
import leftArrow from "../../../Assets/Images/CommanImages/Larrowbar.png";
import rightArrow from "../../../Assets/Images/CommanImages/Rarrowbar.png";
import FileSaver from "file-saver";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import EndPoints from "../../../Api/Endpoints";
import { GET } from "../../../Api/HttpsMethods";

// ── Helpers ───────────────────────────────────────────────────────────────────

// Same logic as TableDetailsQuesList.renderQuestionText —
// decode, split on imgsrc=, render images inline, wrap text in <Latex>.
const renderQuestionText = (questionText) => {
  if (!questionText) return null;
  const decoded = he.decode(questionText);
  const segments = decoded.split(/(imgsrc=[^ ]+)/g);
  return segments.map((segment, index) => {
    if (segment.startsWith("imgsrc=")) {
      const imageUrl = segment.replace("imgsrc=", "");
      return (
        <img
          key={index}
          src={imageUrl}
          alt=""
          onError={(e) => { e.target.style.display = "none"; }}
          style={{ height: "1.4em", width: "auto", objectFit: "contain", verticalAlign: "middle", margin: "0 2px" }}
        />
      );
    }
    return (
      <span key={index}>
        <Latex>{segment}</Latex>
      </span>
    );
  });
};

// ─── TableComponent ───────────────────────────────────────────────────────────
const TableComponent = ({ columnLabels, groupedRows, searchPlaceholder }) => {
  const [isColumnDivVisible, setIsColumnDivVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [visibleColumns, setVisibleColumns] = useState([]);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "desc" });
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const columnDropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (columnLabels.length > 0) {
      setVisibleColumns(columnLabels.slice(0, columnLabels.length));
      setSortConfig({ key: columnLabels[0], direction: "desc" });
    }
  }, [columnLabels]);

  const handleColumnSelection = (col) => {
    setVisibleColumns((prev) =>
      prev.includes(col) ? prev.filter((c) => c !== col) : [...prev, col]
    );
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };

  const handleSort = (col) => {
    setSortConfig((prev) => ({
      key: col,
      direction: prev.key === col && prev.direction === "asc" ? "desc" : "asc",
    }));
  };

  const filteredRows = groupedRows.filter((row) =>
    [row.scheduleDate, row.scheduledBy, row.course, ...(row.questionTexts || [])].some(
      (val) => String(val).toLowerCase().includes(searchQuery.toLowerCase())
    )
  );

  const sortedRows = React.useMemo(() => {
    if (!sortConfig.key) return filteredRows;
    return [...filteredRows].sort((a, b) => {
      const colKeyMap = {
        "Schedule Date": "scheduleDate",
        "Scheduled By": "scheduledBy",
        Course: "course",
        Questions: "scheduleDate",
      };
      const key = colKeyMap[sortConfig.key] || "scheduleDate";
      const aVal = a[key];
      const bVal = b[key];
      if (aVal < bVal) return sortConfig.direction === "asc" ? -1 : 1;
      if (aVal > bVal) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    });
  }, [filteredRows, sortConfig]);

  const totalPages = Math.ceil(sortedRows.length / pageSize);
  const paginatedRows = sortedRows.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const handlePageChange = (page) => setCurrentPage(page);
  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const getCellValue = (row, colLabel) => {
    const map = {
      "Schedule Date": row.scheduleDate,
      "Scheduled By": row.scheduledBy,
      Course: row.course,
      Questions: (row.questionTexts || []).map((q, i) => `${i + 1}. ${q}`).join("\n"),
    };
    return map[colLabel] ?? "";
  };

  const handleExport = (type) => {
    const exportData = sortedRows.map((row) =>
      visibleColumns.map((col) => getCellValue(row, col))
    );
    const fileName = prompt("Enter the file name:");
    if (!fileName) return;

    if (type === "excel" || type === "csv") {
      const ws = XLSX.utils.aoa_to_sheet([visibleColumns, ...exportData]);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
      const ext = type === "csv" ? "csv" : "xlsx";
      const mime =
        type === "csv"
          ? "text/csv"
          : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const file = XLSX.write(wb, { bookType: ext, type: "array" });
      FileSaver.saveAs(new Blob([file], { type: mime }), `${fileName}.${ext}`);
    } else if (type === "pdf") {
      const doc = new jsPDF();
      doc.autoTable({ head: [visibleColumns], body: exportData });
      doc.save(`${fileName}.pdf`);
    }
  };

  const renderPagination = () => {
    const pages = [];
    const addBtn = (i) =>
      pages.push(
        <button
          key={i}
          onClick={() => handlePageChange(i)}
          style={{ borderRadius: "5px" }}
          className={i === currentPage ? "active" : ""}
        >
          {i}
        </button>
      );
    const addDots = (k) =>
      pages.push(
        <span key={k} style={{ borderRadius: "5px" }}>
          ...
        </span>
      );

    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) addBtn(i);
    } else if (currentPage <= 3) {
      for (let i = 1; i <= 3; i++) addBtn(i);
      addDots("d1");
      addBtn(totalPages);
    } else if (currentPage > 3 && currentPage < totalPages - 2) {
      addBtn(1);
      addDots("d1");
      for (let i = currentPage - 1; i <= currentPage + 1; i++) addBtn(i);
      addDots("d2");
      addBtn(totalPages);
    } else {
      addBtn(1);
      addDots("d1");
      for (let i = totalPages - 2; i <= totalPages; i++) addBtn(i);
    }
    return pages;
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (columnDropdownRef.current && !columnDropdownRef.current.contains(e.target)) {
        setIsColumnDivVisible(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div>
      {/* Search + record count row */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: "1.5%",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "82vw",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              border: "1px solid #6A6A6A",
              overflow: "hidden",
            }}
          >
            <input
              type="text"
              placeholder={searchPlaceholder}
              name="search"
              className="search-input-ques-dash"
              onChange={handleSearch}
            />
            <div
              style={{
                width: "1px",
                height: "24px",
                backgroundColor: "#2F2E40",
                margin: "0 4px",
              }}
            />
            <img src={searchicon} alt="search" className="search-icon-ques-dash" />
          </div>
          <div style={{ textAlign: "end", marginTop: "20px", color: "#424242" }}>
            Displaying{" "}
            {Math.min((currentPage - 1) * pageSize + 1, sortedRows.length)} –{" "}
            {Math.min(currentPage * pageSize, sortedRows.length)} of{" "}
            {sortedRows.length} records |{" "}
            {["10", "25", "50", "100", "500"].map((size) => (
              <span
                key={size}
                onClick={() => handlePageSizeChange(Number(size))}
                style={{
                  cursor: "pointer",
                  margin: "0 5px",
                  textDecoration: size === pageSize.toString() ? "none" : "underline",
                  color: size === pageSize.toString() ? "black" : "#337AB7",
                }}
              >
                {size}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* Filter / Column selection bar */}
      <div
        style={{
          display: "flex",
          backgroundColor: "#D6D6D6",
          marginTop: "9px",
          borderTop: "1px solid grey",
          borderBottom: "1px solid grey",
        }}
      >
        {/* Export button */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            cursor: "pointer",
            paddingLeft: "8px",
            width: "90px",
            backgroundColor: "#FFBD20",
          }}
          onClick={() => setIsModalVisible(true)}
        >
          <img src={Filter} style={{ height: "24px", width: "24px" }} alt="export" />
          <span style={{ marginLeft: "10px", color: "#2F2E40" }}>Export</span>
        </div>

        {/* Column selection */}
        <div
          style={{
            marginLeft: "auto",
            textAlign: "end",
            marginRight: "8px",
            display: "flex",
            alignItems: "center",
            position: "relative",
            cursor: "pointer",
            height: "40px",
          }}
          onClick={(e) => {
            if (!columnDropdownRef.current?.contains(e.target)) {
              setIsColumnDivVisible((v) => !v);
            }
          }}
        >
          <img
            src={columnaddition}
            style={{ height: "34px", width: "32px" }}
            alt="column addition"
          />
          <span
            style={{
              marginLeft: "4px",
              color: "#2F2E40",
              marginRight: "14px",
              fontSize: "14px",
            }}
          >
            Column Selection
          </span>
          {isColumnDivVisible && (
            <>
              <div className="arrow-up-tc" />
              <div className="popupColumn-tc" ref={columnDropdownRef}>
                <div>
                  <input
                    type="checkbox"
                    id="col-lock"
                    className="square-checkbox-tc"
                    checked
                    readOnly
                    disabled
                  />
                  <label htmlFor="col-lock">{columnLabels[0]}</label>
                </div>
                {columnLabels.slice(1).map((col, i) => (
                  <div key={i} onClick={() => handleColumnSelection(col)}>
                    <input
                      type="checkbox"
                      id={`col-${i}`}
                      className="square-checkbox-tc"
                      checked={visibleColumns.includes(col)}
                      readOnly
                    />
                    <label htmlFor={`col-${i}`}>{col}</label>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      {/* Table */}
      <div className="table-wrapper-cols-selections">
        <table className="table-tc mcq-dashboard-table" style={{ width: "100%" }}>
          <thead>
            <tr>
              {visibleColumns.map((col, i) => (
                <td
                  key={i}
                  className="Heading-tc"
                  style={{ textAlign: "left", cursor: "pointer" }}
                >
                  <span
                    style={{
                      display: "flex",
                      alignItems: "center",
                      color: "#424242",
                    }}
                  >
                    {col}
                    <img
                      onClick={() => handleSort(col)}
                      src={updown}
                      style={{ height: "20px", width: "20px", marginLeft: "5px" }}
                      alt="sort"
                    />
                  </span>
                </td>
              ))}
            </tr>
          </thead>
          <tbody>
            {paginatedRows.map((row, rowIdx) => (
              <tr key={rowIdx} className={rowIdx % 2 === 1 ? "even-row-tc" : ""}>
                {visibleColumns.map((col, cellIdx) => (
                  <td
                    key={cellIdx}
                    style={{
                      textAlign: "left",
                      color: "#6A6A6A",
                      maxWidth: col === "Questions" ? "500px" : "220px",
                      verticalAlign: "middle",
                      paddingLeft: col === "Questions" ? "8px" : undefined,
                      overflow: "hidden",
                    }}
                  >
                    {col === "Schedule Date" ? (
                      <div className="truncate-cell" title={row.scheduleDate}>
                        <Link
                          style={{ color: "#337ab7" }}
                          to={`/mcq_of_day_edit?date=${encodeURIComponent(row.scheduleDate)}&course=${encodeURIComponent(row.course)}&courseId=${encodeURIComponent(row.courseId || "")}&scheduledBy=${encodeURIComponent(row.scheduledBy)}`}
                        >
                          {row.scheduleDate
                            ? (() => {
                                const d = new Date(row.scheduleDate);
                                if (isNaN(d)) return row.scheduleDate;
                                const dd = String(d.getDate()).padStart(2, "0");
                                const mm = String(d.getMonth() + 1).padStart(2, "0");
                                const yyyy = d.getFullYear();
                                return `${dd}-${mm}-${yyyy}`;
                              })()
                            : ""}
                        </Link>
                      </div>
                    ) : col === "Questions" ? (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "4px 0",
                          alignItems: "flex-start",
                          width: "100%",
                        }}
                      >
                        {(row.questionTexts || []).map((qt, qi) => {
                          const isLast = qi === (row.questionTexts || []).length - 1;

                          return (
                            <div
                              key={qi}
                              style={{
                                fontSize: "13px",
                                color: "#6A6A6A",
                                lineHeight: "1.4",
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                                width: "100%",
                                paddingBottom: isLast ? "0" : "6px",
                                marginBottom: isLast ? "0" : "6px",
                                borderBottom: isLast ? "none" : "1px solid #e8e8e6",
                                overflow: "hidden",
                                minHeight: 0,
                              }}
                            >
                              <span
                                style={{
                                  color: "#6A6A6A",
                                  fontWeight: 400,
                                  minWidth: "18px",
                                  flexShrink: 0,
                                }}
                              >
                                {qi + 1}.
                              </span>
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  flexWrap: "nowrap",
                                  gap: "2px",
                                  minWidth: 0,
                                  flex: 1,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                {renderQuestionText(qt)}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="truncate-cell" title={String(getCellValue(row, col))}>
                        {getCellValue(row, col)}
                      </div>
                    )}
                  </td>
                ))}
              </tr>
            ))}
            {paginatedRows.length === 0 && (
              <tr>
                <td
                  colSpan={visibleColumns.length}
                  style={{ textAlign: "center", padding: "24px", color: "#6A6A6A" }}
                >
                  No records found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination */}
      <div className="pagination-tc">
        <button
          onClick={() => handlePageChange(1)}
          disabled={currentPage === 1}
          className="extreme-left-tc-pagination"
        >
          <img src={leftArrow} alt="" />
        </button>
        <button
          onClick={() => handlePageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className="lefttc-pagination"
        >
          {"<"}
        </button>
        {renderPagination()}
        <button
          onClick={() => handlePageChange(currentPage + 1)}
          disabled={currentPage === totalPages || totalPages === 0}
          className="righttc-pagination"
        >
          {">"}
        </button>
        <button
          onClick={() => handlePageChange(totalPages)}
          disabled={currentPage === totalPages || totalPages === 0}
          className="extreme-right-tc-pagination"
        >
          <img src={rightArrow} alt="" />
        </button>
      </div>

      {/* Export modal */}
      {isModalVisible && (
        <div>
          <div className="arrow-up-tc-QB" />
          <div className="arrow-up-tc-QB-model">
            <div className="modal-content-tc">
              <h3>Select Export File Type</h3>
              <button onClick={() => { handleExport("excel"); setIsModalVisible(false); }}>
                Excel
              </button>
              <button onClick={() => { handleExport("csv"); setIsModalVisible(false); }}>
                CSV
              </button>
              <button onClick={() => { handleExport("pdf"); setIsModalVisible(false); }}>
                PDF
              </button>
              <button onClick={() => setIsModalVisible(false)}>Cancel</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

// ─── MCQDayDashboard (page-level) ─────────────────────────────────────────────
const MCQDayDashboard = ({
  setMessageBox,
  setIsMessageBoxVisible,
  setActiveImg,
  dataClient,
}) => {
  const navigate = useNavigate();
  const [groupedRows, setGroupedRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const clientBranchId =
    dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id ||
    sessionStorage.getItem("clientBranchId") ||
    null;

  useEffect(() => {
    if (dataClient) {
      const userName = dataClient?.client_schema_name?.[6]?.[0]?.user_name || "";
      const branchId = dataClient?.client_schema_name?.[6]?.[0]?.client_branch_id || null;
      const clientId = dataClient?.client_schema_name?.[6]?.[0]?.client_id || null;
      sessionStorage.setItem("user_name", userName);
      sessionStorage.setItem("clientBranchId", branchId);
      sessionStorage.setItem("clientId", clientId);
    }
  }, [dataClient]);

  useEffect(() => {
    fetchMCQDashboardData();
  }, []);

  const fetchMCQDashboardData = async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await GET.withToken(EndPoints.PRISM_GET_ALL_MCQ_OF_DAY_BY_COURSE);

      const DATE_IDX = 0;
      const BY_IDX = 1;
      const COURSE_IDX = 2;
      const TEXT_IDX = 3;

      const groupMap = new Map();

      const dataRows = Array.isArray(data.headers)
        ? data.headers.filter((h) => Array.isArray(h))
        : [];

      dataRows.forEach((row) => {
        const rawDate = row[DATE_IDX];
        const course = row[COURSE_IDX] || "";
        const scheduledBy = row[BY_IDX] || "";
        const questionText = row[TEXT_IDX] || "";
        const displayDate = rawDate ? rawDate.split(" ")[0] : rawDate;
        const key = `${rawDate}__${course}`;

        if (!groupMap.has(key)) {
          groupMap.set(key, {
            rawDate,
            scheduleDate: displayDate,
            scheduledBy,
            course,
            courseId: null,
            questionTexts: [],
          });
        }
        if (questionText) {
          groupMap.get(key).questionTexts.push(questionText);
        }
      });

      setGroupedRows(Array.from(groupMap.values()));
    } catch (err) {
      console.error("Error fetching MCQ dashboard data:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const columnLabels = ["Schedule Date", "Scheduled By", "Course", "Questions"];

  return (
    <div
      style={{
        height: "auto",
        width: "100%",
        paddingLeft: "20px",
        marginBottom: "40px",
      }}
    >
      <div style={{ position: "sticky", top: "0", paddingLeft: "15px" }}>
        <div className="create-role-container-ques-dashboards">
          <p style={{ color: "#2F2E40", fontSize: "30px" }}>MCQ of the Day Dashboard</p>
          <div
            style={{
              display: "flex",
              justifyItems: "center",
              alignItems: "center",
              gap: "12px",
            }}
          >
            <button
              className="create-test-section-btn"
              onClick={() => navigate("/mcq_of_day")}
              style={{
                marginRight: "18px",
                boxShadow: "0px 4px 4px 0px #00000040",
              }}
            >
              <span className="plus-icon-create">+</span>MCQ OF DAY
            </button>
          </div>
        </div>

        <p style={{ marginTop: "1%", color: "#2F2E40" }}>
          View and manage MCQ of the Day schedules. Click on a date to edit.
        </p>

        {loading && (
          <p style={{ color: "#6A6A6A", marginTop: "12px" }}>Loading…</p>
        )}
        {error && (
          <p style={{ color: "red", marginTop: "12px" }}>Error: {error}</p>
        )}

        {!loading && !error && (
          <TableComponent
            columnLabels={columnLabels}
            groupedRows={groupedRows}
            searchPlaceholder="Search MCQ schedules…"
          />
        )}
      </div>
    </div>
  );
};

export default MCQDayDashboard;